import React from "react";
import { Box } from "@mui/material";
import bgDesign1 from "../../../assets/icons/SM_long_flower_white.png";
import bgDesign2 from "../../../assets/icons/SM_short_flower_white.png";

const decorationOpacity = 0.10

export const BACKGROUND_DESIGNS = {
    1: () => (
        <>
                {/* Left */}
                <Box
                    component="img"
                    src={bgDesign1}
                    aria-hidden
                    sx={{
                            position: "absolute",
                            top: { xs: -350, sm: -300, md: -350, lg: -350, xl: -400 },
                            left: { xs: -650, sm: -650, md: -750, lg: -750, xl: -850 },
                            width: { xs: 800, sm: 800, md: 900, lg: 900, xl: 1000 },
                            opacity: decorationOpacity,
                            pointerEvents: "none",
                            transform: "rotate(90deg)",
                            transformOrigin: "center",
                    }}
                />

                {/* Right (mirror of left) */}
                <Box
                    component="img"
                    src={bgDesign1}
                    aria-hidden
                    sx={{
                            position: "absolute",
                            top: { xs: -350, sm: -300, md: -350, lg: -350, xl: -400 },
                            right: { xs: -650, sm: -650, md: -750, lg: -750, xl: -850 }, // ✅ use right
                            width: { xs: 800, sm: 800, md: 900, lg: 900, xl: 1000 },
                            opacity: decorationOpacity,
                            pointerEvents: "none",
                            transform: "rotate(90deg) scaleY(-1)", // ✅ reflection
                            transformOrigin: "center",
                    }}
                />
        </>
    ),
    2: () => (
        <>
            {/* Top Middle */}
            <Box
                component="img"
                src={bgDesign1}
                aria-hidden
                sx={{
                    position: "absolute",
                    top: { xs: -900, sm: -950, md: -950, lg: -950, xl: -1100 },
                    left: { xs: -280, sm: -300, md: -240, lg: -250, xl: -250 },
                    width: { xs: 900, sm: 950, md: 950, lg: 950, xl: 1100 },
                    opacity: decorationOpacity,
                    pointerEvents: "none",
                    transform: "rotate(180deg)",
                    transformOrigin: "center",
                }}
            />
        </>
    ),
    3: () => (
        <>
            {/* Large Centered */}
            <Box
                component="img"
                src={bgDesign2}
                aria-hidden
                sx={{
                    position: "absolute",
                    top: { xs: -100, sm: -100, md: -100, lg: -100, xl: -100 },
                    left: { xs: -60, sm: -150, md: -60, lg: -100, xl: -50 },
                    width: { xs: 500, sm: 600, md: 600, lg: 600, xl: 700 },
                    opacity: decorationOpacity,
                    pointerEvents: "none",
                    transformOrigin: "center",
                }}
            />
        </>
    ),
};
